import React, { Component } from "react";
import PropTypes from 'prop-types';

import { Link } from "react-router-dom";
import { Utils } from "../utils/Utils";
import { LoginData } from "../utils/Login";
import { ParamsStr, calculation } from "../lib/InterfaceCalculation";
import { AUTH } from "../utils/Req";
import "../static/css/login-register.css";

import InputPhone from "../components/login/InputPhone";
import DeviceBindDialog from '../components/Device/DeviceBindDialog';
import DeviceManagement from '../components/Device/DeviceManagement';

function getHashQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r =
        window.location.hash.split("?") &&
            window.location.hash.split("?").length > 1
            ? window.location.hash.split("?")[1].match(reg)
            : null;
    if (r != null) return r[2];
    else return null;
}

// 加入了微信登录，重定向的时候在 url 中传入 状态（）
const ReqGET = {
    method: "GET"
};

const url = `https://open.weixin.qq.com/connect/qrconnect?appid=wx9b8434fed9a35dd8&redirect_uri=https%3a%2f%2fwww.putaoabc.com%2fai_course%2f%23%2flogin%3fid%3d5&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e&href=${encodeURIComponent(
    window.location.origin + window.publicUrl + "static/css/weixin.css"
)}#wechat_redirect`;

const ua = navigator.userAgent.toLocaleLowerCase();
const isWX = ua.indexOf("micromessenger") > -1 ? true : false;

window.isMobile = ua.indexOf("micromessenger") > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('iphone') > -1 || ua.indexOf('android') > -1 ? true : false;

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginState: null,
            msgOne: "",
            msgTwo: "",
            phone: "",
            password: "",
            passwordType: "password",
            passwordTypeOne: "password",
            passwordOne: "",
            passwordTwo: "",
            // 验证码发送成功后，需要添加一个定时器，在该定时器时间内，按钮禁用
            messageCode: "",
            // 小按钮的禁用 （当定时器开启的时候，发送按钮处于禁用状态，到达指定时间后可以重新发送）
            disableSmall: false,
            // 小按钮中显示的字
            sendText: "发送",
            sendTimer: 60,
            showBack: false,
            agree: true,
            // 登录成功后也需要一个定时器
            successTimer: 3,
            toast: "",
            // 添加区号
            showAllCountry: false,
            currentCountry: null,
            showDeviceDialog: false, // 是否显示绑定设备弹窗
            showDeviceManagement: false, // 是否显示设备管理

        };
        this.OnkeyDownHandler = this.OnkeyDownHandler.bind(this);
        this.hashChangeHandler = this.hashChangeHandler.bind(this);

        // 兼容获取其他参数，这里会点击切换登录方式
        this.reUrl = Utils.getHashQueryString("url");
        this.login_from = Utils.getHashQueryString("login_from");
        this.source = Utils.getHashQueryString('source');
        this.sourceToken = Utils.getHashQueryString('sourceToken');
        this.ParamsStr = ParamsStr(this.login_from);

        if (this.source) {
            this.ParamsStr += `&source=${this.source}`
        } else {
            this.ParamsStr += `&source=2011`;
        }

        if (this.sourceToken) {
            this.ParamsStr += `&sourceToken=${this.sourceToken}`
        }
    }

    componentDidMount() {
        this.hashChangeHandler();
        this.addHashChangeHandler();
        this.addOnkeyDownHandler();

        if (window.isMobile) {
            const rootElement = document.querySelector('#root');

            if (rootElement) {
                rootElement.setAttribute('ontouchmove', '');
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.sendTimer);
        window.removeEventListener("keydown", this.OnkeyDownHandler);
        window.removeEventListener("hashchange", this.hashChangeHandler);

        if (window.isMobile) {
            const rootElement = document.querySelector('#root');

            if (rootElement) {
                rootElement.setAttribute('ontouchmove', 'event.preventDefault();');
            }
        }
    }

    // 添加 hash 改变的事件
    addHashChangeHandler() {
        window.addEventListener("hashchange", this.hashChangeHandler, false);
    }

    // 添加键盘键入时间
    addOnkeyDownHandler() {
        window.addEventListener("keydown", this.OnkeyDownHandler);
    }

    OnkeyDownHandler(e) {
        if (e.keyCode === 13) {
            document.querySelector(".login-button").focus();
        }
    }

    hashChangeHandler() {
        let { loginState } = this.state;

        // 根据 url 获取当前的状态
        let id = Utils.getHashQueryString("id");

        if (id) {
            this.setState({ showBack: true, msgOne: "", msgTwo: "" });
        } else {
            this.setState({ showBack: false });
            id = window.localStorage.getItem('loginWay') ? window.localStorage.getItem('loginWay') : '2'
        }
        switch (id) {
            case "1":
                loginState = LoginData.PhonePasswordLogin;
                window.localStorage.setItem('loginWay', '1');
                break;
            case "2":
                loginState = LoginData.VerificatePhoneLogin;
                window.localStorage.setItem('loginWay', '2');
                break;
            case "3":
                loginState = LoginData.SetPassword;
                break;
            case "4":
                loginState = LoginData.BindPhone;
                break;
            case "5":
                loginState = LoginData.WeixinLogin;
                break;
            case "6":
                loginState = LoginData.ForgetPassword;
                break;
            case "7":
                loginState = LoginData.ResetPassword;
                break;
            case "8":
                loginState = LoginData.LoginSuccess;
                break;
            default:
                loginState = LoginData.VerificatePhoneLogin;
        }

        this.setState({ loginState }, () => {
            if (id === "8") {
                this.loginSuccess();
            }
        });

        // 在这里获取到微信用户所有的信息
        if (
            getHashQueryString("id") &&
            getHashQueryString("id") === "5" &&
            getHashQueryString("code")
        ) {
            this.wx_code = getHashQueryString("code");
            this.wx_state = getHashQueryString("state");
            // 放在这里发送 微信登入的请求。判断是否绑定了手机号
            const req = new Request(
                `${AUTH}/login_wx?phone=${this.state.phone}${this.ParamsStr}&code=${this.wx_code
                }&state=${this.wx_state}`,
                ReqGET
            );

            fetch(req)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    // 正确返回
                    if (data.code === 200) {
                        if (data.code === 200 && data.hasPhoneNum === true) {
                            this.writePutaoIdAndToken(data.putaoid, data.token, false, data);
                        } else {
                            this.changeStateHandler(`#/login?id=4`);
                        }
                    }
                });
        }
    }

    // 输入框改变（输入验证也在这里）
    changeInputHandler(e, key, inputCount) {
        e.preventDefault();

        const value =
            key.indexOf("password") < 0
                ? e.target.value.replace(/\D/g, "")
                : e.target.value;
        this.setState({
            [key]: value
        });

        if (key === "phone" && e.target.value.length > 10) {
            this.onBlurHandler(e, key, inputCount);
        }
        if (key !== "phone") {
            this.setState({ msgOne: "", msgTwo: "" });
        }
    }

    // onBlur 的逻辑
    onBlurHandler(e, key, inputCount) {
        const { currentCountry } = this.state;

        if (!(currentCountry && currentCountry.preg)) {
            return;
        }
        // 验证数据正则
        // const regPhone = /^1[345789]\d{9}$/;
        const regPhone = new RegExp(currentCountry.preg);
        const regPassword = /^[a-zA-Z0-9]{6,20}$/;
        const regMsgCode = /^\d*$/;

        if (key === "phone") {
            const value = e.target.value;
            if (regPhone.test(value) === false) {
                // 需要根据输入框的号来渲染错误信息
                if (inputCount === "one") {
                    this.setState({ msgOne: "手机号异常，请检查" });
                } else if (inputCount === "two") {
                    this.setState({ msgTwo: "手机号异常，请检查" });
                }
            } else {
                this.setState({ msgOne: "", msgTwo: "" });
            }
        }

        if (key === "password" || key === "passwordOne") {
            //如果是修改密码等，第二个输入框改变时就要判断输入是否一致
            if (regPassword.test(e.target.value) === false) {
                // 需要根据输入框的号来渲染错误信息
                if (inputCount === "one") {
                    this.setState({ msgOne: "6-20位，请使用数字、字母或组合" });
                } else if (inputCount === "two") {
                    this.setState({ msgTwo: "6-20位，请使用数字、字母或组合" });
                }
                // else if (inputCount === "two") {
                //   // 去掉确认密码的情况
                //   if (key !== "passwordTwo") {
                //     this.setState({ msgTwo: "6-20位，请使用数字、字母或组合" });
                //   }
                // }
            } else {
                this.setState({ msgOne: "", msgTwo: "" });
            }
        }

        if (key === "passwordTwo") {
            this.setState({
                msgTwo:
                    e.target.value !== this.state.passwordOne &&
                    "两次输入不一致"
            });
        }
        if (key === "passwordOne" && this.state.passwordTwo) {
            this.setState({
                msgTwo:
                    e.target.value !== this.state.passwordTwo &&
                    "两次输入不一致"
            });
        }

        // if (key === "messageCode") {
        //   if (regMsgCode.test(e.target.value) === false) {
        //     if (inputCount === "one") {
        //       this.setState({ msgOne: "格式错误" });
        //     } else if (inputCount === "two") {
        //       this.setState({ msgTwo: "格式错误" });
        //     }
        //   } else {
        //     this.setState({ msgOne: "", msgTwo: "" });
        //   }
        // }
    }

    // 点击发送(倒计时没有结束不能点击)
    sendMessageCodeHandler(id) {
        // if (elelments[1]) {
        //   elelments[1].onBlur();
        // }
        const {
            disableSmall,
            sendTimer,
            msgOne,
            phone,
            currentCountry
        } = this.state;

        // 点击发送的时候再判断一次
        const regPhone = new RegExp(currentCountry.preg);
        if (regPhone.test(phone) === false) {
            // 需要根据输入框的号来渲染错误信息
            this.setState({ msgOne: "手机号异常，请检查" });
        } else {
            if (!disableSmall) {
                this.setState({ disableSmall: disableSmall === true });

                // 登录、注册、找回密码的验证码接口不同
                // 发送验证码
                let url;
                if (id === 2) {
                    url = AUTH + "/login_verify";
                }
                if (id === 4) {
                    url = AUTH + "/reg_wx_verify";
                }
                if (id === 6) {
                    url = AUTH + "/reset_pw_verify";
                }
                const req = new Request(
                    `${url}?phone=${this.state.phone
                    }${this.ParamsStr}&country_code=${currentCountry.code}`,
                    ReqGET
                );

                if (id === 2 || id === 6) {
                    this.requestVCode(req);
                } else if (id === 4) {
                    fetch(
                        `${AUTH}/login_wx_check?phone=${this.state.phone
                        }${this.ParamsStr}&code=${this.wx_code}&state=${this.wx_state
                        }&country_code=${currentCountry.code}`,
                        ReqGET
                    )
                        .then(res => res.json())
                        .then(data => {
                            if (data.code === 401) {
                                // this.tipsMessage("该手机号已绑定其他微信，请更换手机号", 2000);
                                this.setState({
                                    msgOne:
                                        "该手机号已绑定其他微信，请更换手机号"
                                });
                            } else {
                                if (data.code === 200) {
                                    this.changeStateHandler(
                                        `#/login?id=4&isWX=true`
                                    );
                                } else if (data.code === 202) {
                                    // this.changeStateHandler(`#/login?id=4`);
                                } else {
                                    this.setState({ msgOne: data.msg || "" });
                                }

                                this.requestVCode(req);
                            }
                        });
                }

                // 添加倒计时
                this.sendTimer = setInterval(() => {
                    // 倒计时完成后，将倒计时数重置为原本的
                    this.doLoop(sendTimer);
                }, 1000);
            } else {
                return null;
            }
        }
    }

    // 请求验证码
    requestVCode(req) {
        fetch(req)
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.code === 200) {
                    // this.tipsMessage("验证码已发送，请稍等...", 2000);
                    this.setState({ msgTwo: "验证码已发送，请稍等..." });
                    // 判断需不需要改变状态
                    if (true) {
                    }
                }
                if (data.code === 403) {
                    this.setState({ msgOne: "0手机号未注册，" });
                }
                if (data.code === 401) {
                    // this.tipsMessage("该手机号已绑定其它微信，请更换手机号", 2000);
                    this.setState({
                        msgOne: "该手机号已绑定其它微信，请更换手机号"
                    });
                }
                if (data.code === 433) {
                    // this.tipsMessage("验证码发送太频繁，请稍后尝试", 3000);
                    this.setState({ msgTwo: "验证码发送太频繁，请稍后尝试" });
                }
            });
    }

    // 倒计时的逻辑
    doLoop(sendTimer) {
        let num = this.state.sendTimer;

        this.setState({
            sendTimer: --num
        });

        if (num > 0) {
            this.setState({ sendText: `${num}s`, disableSmall: true });
        } else {
            clearInterval(this.sendTimer);
            this.setState({ sendText: "发送", disableSmall: false, sendTimer });
        }
    }

    weixinLoginHandler() {
        this.changeStateHandler(`#/login?id=5`);
    }

    bigButtonHandler(loginState) {
        const { msgOne, msgTwo, currentCountry, phone } = this.state;
        const putaoid = Utils.getCookie("putaoid");
        const token = encodeURIComponent(Utils.getCookie("token"));

        var elements = document.getElementsByTagName("input");

        // 再做一次手机号的验证
        const regPhone = new RegExp(currentCountry && currentCountry.preg);
        if (regPhone.test(phone) === false) {
            // 需要根据输入框的号来渲染错误信息
            this.setState({ msgOne: "手机号异常，请检查" });
            return;
        }

        if (elements[0]) {
            elements[0].blur();
        }

        if (elements[1]) {
            elements[1].blur();
        }

        if (msgOne || msgTwo) {
            return;
        }
        // 登录页首页，输入手机号和密码登录
        if (loginState.id === 1) {
            const req = new Request(
                `${AUTH}/login?phone=${this.state.phone}&pw=${this.state.password
                }${this.ParamsStr}&country_code=${currentCountry.code}`,
                ReqGET
            );

            fetch(req)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.code === 402) {
                        // this.tipsMessage("手机号或密码错误", 2000);
                        this.setState({ msgTwo: "手机号或密码错误" });
                    } else if (data.code === 302) {
                        this.setState({ msgOne: "0未设置密码，请用 " });
                    } else if (data.code === 200) {
                        // 登录成功，写入 cookie， 并且跳转
                        this.writePutaoIdAndToken(data.putaoid, data.token, false, data);
                    } else {
                        this.setState({ msgTwo: data.msg || "" });
                    }
                });
        }

        // 输入验证码登录
        if (loginState.id === 2) {
            if (this.state.agree) {
                const req = new Request(
                    `${AUTH}/login_phone?phone=${this.state.phone}&vcode=${this.state.messageCode
                    }${this.ParamsStr}&country_code=${currentCountry.code}`,
                    ReqGET
                );

                fetch(req)
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.code === 402) {
                            // this.tipsMessage("验证码错误", 2000);
                            this.setState({ msgTwo: "验证码错误" });
                        } else if (data.code === 200) {
                            // 登录成功，写入 cookie， 并且跳转
                            if (data.exist !== true) {
                                this.changeStateHandler(`#/login?id=3`);
                                this.writePutaoIdAndToken(
                                    data.putaoid,
                                    data.token,
                                    "unLink",
                                    data
                                );
                            } else {
                                this.writePutaoIdAndToken(
                                    data.putaoid,
                                    data.token,
                                    false,
                                    data
                                );
                            }
                        } else {
                            this.setState({ msgTwo: data.msg || "" });
                        }
                    });
            } else {
                this.setState({ toast: "尚未同意“用户协议和隐私协议”" });
                this.timeout = setTimeout(() => {
                    this.setState({ toast: "" });
                }, 2000);
            }
        }

        // 设置密码
        if (loginState.id === 3) {
            const requestParams = calculation(putaoid, this.login_from);

            const req = new Request(
                `${AUTH}/login_create_password?phone=${this.state.phone
                }&vcode=${this.state.messageCode}&pw=${this.state.password
                }&isWX=${Utils.getHashQueryString("isWX") ? "1" : "0"
                }&putaoid=${putaoid}&token=${token}&uuid=${requestParams.uuid
                }&ts=${requestParams.ts}&sign=${requestParams.sign}&from=${requestParams.from
                }&country_code=${currentCountry.code}`,
                ReqGET
            );

            fetch(req)
                .then(res => res.json())
                .then(data => {
                    if (data.code === 200) {
                        // this.tipsMessage("密码设置成功", 2000, () => {
                        //   this.changeStateHandler(`#/login?id=8`);
                        // });
                        this.changeStateHandler(`#/login?id=8`);
                    }
                    if (data.code === 203) {
                        // this.tipsMessage(
                        //   "已超时，密码设置失败。请通过“忘记密码”重设",
                        //   3000
                        // );
                        this.setState({
                            msgOne: "已超时，密码设置失败。请通过“忘记密码”重设"
                        });
                    }
                });
        }

        // 微信登入时的绑定手机
        // 微信登陆，扫码成功(点击发送验证码的时候会先判断手机号是否存在，根据返回的 code 判断是否要发送验证码的请求)
        if (loginState.id === 4) {
            const req = new Request(
                `${AUTH}/reg_wx?phone=${this.state.phone}&vcode=${this.state.messageCode
                }${this.ParamsStr}&code=${this.wx_code}&state=${this.wx_state
                }&country_code=${currentCountry.code}`,
                ReqGET
            );

            fetch(req)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.code === 200) {
                        //如果手机号没有注册，就到 “设置密码” 状态，否则到登录成功状态，等待几秒跳转到首页
                        if (Utils.getHashQueryString("isWX")) {
                            this.writePutaoIdAndToken(
                                data.putaoid,
                                data.token,
                                "unLink",
                                data
                            );
                            this.changeStateHandler(`#/login?id=3&isWX=true`);
                        } else {
                            this.writePutaoIdAndToken(data.putaoid, data.token, false, data);
                        }
                    }
                    if (data.code === 402) {
                        this.setState({ msgTwo: "验证码错误" });
                    }
                });
        }

        // 忘记密码
        if (loginState.id === 6) {
            const req = new Request(
                `${AUTH}/reset_pw_check?phone=${this.state.phone}&vcode=${this.state.messageCode
                }${this.ParamsStr}&country_code=${currentCountry.code}`,
                ReqGET
            );

            fetch(req)
                .then(res => res.json())
                .then(data => {
                    if (data.code === 200) {
                        this.changeStateHandler(`#/login?id=7`);
                    } else if (data.code === 402) {
                        // this.tipsMessage("验证码错误", 2000);
                        this.setState({ msgTwo: "验证码错误" });
                    }
                });
        }

        //  重设密码
        if (loginState.id === 7) {
            const req = new Request(
                `${AUTH}/reset_pw?phone=${this.state.phone}&vcode=${this.state.messageCode
                }&pw=${this.state.passwordOne}${this.ParamsStr}&country_code=${currentCountry.code
                }`,
                ReqGET
            );

            fetch(req)
                .then(res => res.json())
                .then(data => {
                    if (data.code === 200) {
                        // this.tipsMessage("设置成功", 1000, () => {
                        //   this.changeStateHandler(`#/login`);
                        // });
                        this.changeStateHandler(`#/login`);
                    } else if (data.code === 402) {
                        // this.tipsMessage(
                        //   "已超时，密码设置失败。请通过“忘记密码”重设",
                        //   2000
                        // );
                        this.setState({
                            msgTwo: "已超时，密码设置失败。请通过“忘记密码”重设"
                        });
                    }
                });
        }

        // 跳转到首页
        if (loginState.id === 8) {
            this.changeStateHandler(`#/`);
        }
    }

    // 登录成功
    loginSuccess() {
        const { successTimer } = this.state;
        // 注册成功后五秒返回首页
        this.successTimer = setInterval(() => {
            this.successDoLoop(successTimer);
        }, 1000);
        this.context.getUser();
    }

    // 注册成功的倒计时
    successDoLoop(successTimer) {
        let num = this.state.successTimer;
        this.setState({ successTimer: --num });

        if (num <= 0) {
            window.location = `${window.location.pathname}${window.location.search}#/`;
            clearInterval(this.successTimer);
            this.setState({ successTimer: successTimer });
        }
    }

    // 写入 token 和 putaoid，并跳转到首页或其他页
    writePutaoIdAndToken(putaoid, token, link, resData) {
        Utils.setCookie("putaoid", putaoid, 720, window.location.hostname, "/");
        Utils.setCookie("token", token, 720, window.location.hostname, "/");

        this.context.getUser();

        // 是否需要显示设备检测的弹窗
        if (resData && resData.showPopUp) {
            this.setState({
                showDeviceDialog: true
            });
        } else if (!link) {
            this.successLink();
        }
    }

    // 状态的跳转逻辑
    changeStateHandler(updateState) {
        console.log(updateState, window.publicUrl)
        if (window.PuTaoA && window.PuTaoA.passthroughLocation) {
            window.PuTaoA.passthroughLocation(updateState);
        } else {
            window.location.href = updateState;
        }
        this.setState({
            password: "",
            msgOne: "",
            msgTwo: "",
            passwordOne: "",
            passwordTwo: ""
        });

        if (updateState.indexOf("id=4&isWX") >= 0) {
            return;
        } else if (
            updateState.indexOf("id=4") >= 0 ||
            updateState.indexOf("id=6") >= 0
        ) {
            this.setState({
                phone: ""
            });
        }
        if (
            updateState.indexOf("id=2") >= 0 ||
            updateState.indexOf("id=4") >= 0 ||
            updateState.indexOf("id=6") >= 0
        ) {
            this.setState({
                messageCode: ""
            });
        }
    }

    //添加固定秒数的提示（添加了提示结束的回调函数）
    tipsMessage(text, second, callback) {
        this.setState({ tips: text });
        if (typeof callback === "function") {
            this.timeout = setTimeout(() => {
                this.setState({ tips: "" }, callback());
            }, second);
        } else {
            this.timeout = setTimeout(() => {
                this.setState({ tips: "" });
            }, second);
        }
    }

    //  选择地区显示与隐藏
    showAllCountryHandler(e) {
        if (e.target && e.target.className === "choose-country") {
            this.setState({
                showAllCountry: true
            });
        } else {
            this.setState({
                showAllCountry: false
            });
        }
    }

    // 修改手机号的正则
    changeCountryHandler(currentCountry) {
        const { phone } = this.state;
        this.setState({ currentCountry }, () => {
            this.verifyPhone();
            // if (phone && !result) {
            //   this.setState({ msgOne: "手机号异常，请检查" });
            // }
        });

        console.log(currentCountry);
    }

    // 验证手机号
    verifyPhone() {
        const { currentCountry, phone } = this.state;
        console.log(currentCountry);

        const regPhone = new RegExp(currentCountry.preg);
        if (!phone) {
            return false;
        }
        if (phone) {
            if (regPhone.test(phone) === false) {
                // 需要根据输入框的号来渲染错误信息
                // this.setState({ msgOne: "手机号异常，请检查" });
                return false;
            } else {
                this.setState({ msgOne: "" });
                return true;
            }
        }
    }

    // 退出登录
    handleLoginOut = () => {
        Utils.delCookie("putaoid", window.location.hostname, "/");
        Utils.delCookie("token", window.location.hostname, "/");

        window.location = `#/login`;

        this.setState({
            showDeviceDialog: false
        });
    }

    handleShowDeviceManagement = () => {
        this.setState({
            showDeviceManagement: true
        });
    }

    successLink = () => {
        const redirect = Utils.getHashQueryString("redirect");
        if (redirect) {
            window.location = `${window.location.pathname}${window.location.search}#/${redirect}`;
        } else if (this.reUrl) {
            console.log(this.reUrl);
            window.location.replace(decodeURIComponent(this.reUrl));
        } else {
            window.location = `${window.location.pathname}${window.location.search}#/?login_from=${this.login_from ? this.login_from : 'pc'}`;
        }
    }

    handleDeviceManagementBack = () => {
        this.setState({
            showDeviceManagement: false
        });
    }

    render() {
        const {
            msgOne,
            msgTwo,
            loginState,
            disableSmall,
            sendText,
            showBack,
            successTimer,
            toast,
            showAllCountry,
            showDeviceDialog,
            showDeviceManagement,
        } = this.state;

        return (
            <React.Fragment>
                <div
                    id="login"
                    className="container"
                    onClick={e => {
                        this.showAllCountryHandler(e);
                    }}
                >
                    {showBack && (
                        <div
                            className="go-back"
                            onClick={() => {
                                window.history.back();
                            }}
                        />
                    )}
                    {toast ? (
                        <div className="login-register-toast">{toast}</div>
                    ) : null}

                    {loginState && (
                        <div className="login-container">
                            <div className={document.referrer && document.referrer.indexOf("https://www.putaoabc.com/onlinepages/course2/?code=1") > -1 ? "login-container-nologo" : "login-container-logo"}></div>
                            {loginState.title &&
                                // (loginState.id === 2 ? (
                                //     <div className="login-logo">步步ABC</div>
                                // ) : (
                                <div className="login-text">
                                    {loginState.title}
                                </div>
                                // ))
                            }
                            {loginState.titleBig && (
                                <div className="login-text">
                                    {loginState.titleBig}
                                </div>
                            )}
                            {loginState.titleSmall && (
                                <div className="register-small-title">
                                    {loginState.titleSmall}{" "}
                                    {loginState.hasPhone && this.state.phone}
                                </div>
                            )}

                            {/* 登陆成功 */}
                            {loginState.success && (
                                <div>
                                    <div className="register-success" />
                                    <div className="register-success-message">
                                        {successTimer} 秒后跳转到首页
                                </div>
                                </div>
                            )}

                            {/* 用来阻止浏览器自动填入 */}
                            <input type='password' style={{ display: 'none' }} />

                            {/* 如果是微信登录，就把页面嵌入里面 */}
                            {loginState.id === 5 && (
                                <iframe
                                    title="wxLogin"
                                    style={{
                                        border: "none",
                                        height: "100%",
                                        width: '100%'
                                    }}
                                    src={url}
                                />
                            )}

                            {/* 新更新的 */}
                            {(loginState.id === 1 ||
                                loginState.id === 2 ||
                                loginState.id === 4 ||
                                loginState.id === 6) &&
                                loginState.inputOne && (
                                    <InputPhone
                                        input={loginState.inputOne}
                                        msgOne={msgOne}
                                        value={this.state[loginState.inputOne.id]}
                                        onChange={e => {
                                            this.changeInputHandler(
                                                e,
                                                loginState.inputOne.id,
                                                "one"
                                            );
                                        }}
                                        onBlur={e => {
                                            this.onBlurHandler(
                                                e,
                                                loginState.inputOne.id,
                                                "one"
                                            );
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                [`${loginState.inputOne.id}`]: ""
                                            });
                                        }}
                                        changeStateHandler={this.changeStateHandler.bind(
                                            this
                                        )}
                                        showAllCountry={showAllCountry}
                                        changeCountryHandler={this.changeCountryHandler.bind(
                                            this
                                        )}
                                    />
                                )}

                            {(loginState.id === 3 || loginState.id === 7) && (
                                <InputPassword
                                    input={loginState.inputOne}
                                    msg={msgOne}
                                    value={this.state[loginState.inputOne.id]}
                                    type={this.state.passwordTypeOne}
                                    onChange={e => {
                                        this.changeInputHandler(
                                            e,
                                            loginState.inputOne.id,
                                            "one"
                                        );
                                    }}
                                    onBlur={e => {
                                        this.onBlurHandler(
                                            e,
                                            loginState.inputOne.id,
                                            "one"
                                        );
                                    }}
                                    onClick={() => {
                                        this.setState({
                                            passwordTypeOne:
                                                this.state.passwordTypeOne ===
                                                    "password"
                                                    ? "text"
                                                    : "password"
                                        });
                                    }}
                                />
                            )}

                            {loginState.inputTwo &&
                                (loginState.id === 1 || loginState.id === 7) && (
                                    <InputPassword
                                        input={loginState.inputTwo}
                                        value={this.state[loginState.inputTwo.id]}
                                        type={this.state.passwordType}
                                        msg={msgTwo}
                                        onChange={e => {
                                            this.changeInputHandler(
                                                e,
                                                loginState.inputTwo.id,
                                                "two"
                                            );
                                        }}
                                        onBlur={e => {
                                            // 如果是登录的时候，输入密码的时候没有错误提示
                                            loginState.inputTwo.id === "password"
                                                ? this.onBlurHandler(
                                                    e,
                                                    loginState.inputTwo.id
                                                )
                                                : this.onBlurHandler(
                                                    e,
                                                    loginState.inputTwo.id,
                                                    "two"
                                                );
                                        }}
                                        onClick={() => {
                                            this.setState({
                                                passwordType:
                                                    this.state.passwordType ===
                                                        "password"
                                                        ? "text"
                                                        : "password"
                                            });
                                        }}
                                    />
                                )}

                            {loginState.inputTwo &&
                                (loginState.id === 2 ||
                                    loginState.id === 4 ||
                                    loginState.id === 6) && (
                                    <div
                                        className="input-container"
                                        style={{ position: "relative" }}
                                    >
                                        <input
                                            placeholder={
                                                loginState.inputTwo.placeholder
                                            }
                                            className={
                                                loginState.inputTwo.className
                                            }
                                            value={
                                                this.state[loginState.inputTwo.id]
                                            }
                                            name={loginState.inputTwo.name}
                                            maxLength={4}
                                            onChange={e => {
                                                this.changeInputHandler(
                                                    e,
                                                    loginState.inputTwo.id,
                                                    "two"
                                                );
                                                this.onBlurHandler(
                                                    e,
                                                    loginState.inputTwo.id,
                                                    "two"
                                                );
                                            }}
                                        // onBlur={e => {
                                        //   this.onBlurHandler(e, loginState.inputTwo.id, "two");
                                        // }}
                                        />
                                        {this.state.phone.length > 0 &&
                                            this.verifyPhone.bind(this) &&
                                            !msgOne && (
                                                <button
                                                    className="code-send"
                                                    style={{
                                                        background:
                                                            this.verifyPhone.bind(
                                                                this
                                                            ) &&
                                                            !msgOne &&
                                                            (!disableSmall
                                                                ? `url(${require("../static/img/login-register/send.png")}) center / 100%`
                                                                : `url(${require("../static/img/login-register/already-send.png")}) center / 100%`),
                                                        cursor:
                                                            this.verifyPhone.bind(
                                                                this
                                                            ) && !msgOne
                                                                ? "pointer"
                                                                : "default"
                                                    }}
                                                    disabled={
                                                        this.verifyPhone.bind(
                                                            this
                                                        ) && !msgOne
                                                            ? false
                                                            : disableSmall
                                                    }
                                                    onClick={() => {
                                                        !msgOne &&
                                                            this.sendMessageCodeHandler(
                                                                loginState.id
                                                            );
                                                    }}
                                                >
                                                    {sendText}
                                                </button>
                                            )}

                                        {msgTwo && (
                                            <div className="msg">{msgTwo}</div>
                                        )}
                                    </div>
                                )}

                            {loginState.id !== 5 && (
                                // <div>
                                <button
                                    className="login-button"
                                    disabled={
                                        loginState.inputOne
                                            ? loginState.inputTwo
                                                ? this.state[
                                                    loginState.inputOne.id
                                                ] &&
                                                    (loginState.inputOne.className ===
                                                        "password"
                                                        ? this.state[
                                                            loginState.inputOne.id
                                                        ].length > 5
                                                        : true) &&
                                                    this.state[
                                                    loginState.inputTwo.id
                                                    ] &&
                                                    (loginState.inputTwo.className ===
                                                        "password"
                                                        ? this.state[
                                                            loginState.inputTwo.id
                                                        ].length > 5
                                                        : this.state[
                                                            loginState.inputTwo.id
                                                        ].length > 3) &&
                                                    !msgOne &&
                                                    !msgTwo
                                                    ? false
                                                    : true
                                                : this.state[
                                                    loginState.inputOne.id
                                                ] &&
                                                    !msgOne &&
                                                    this.state[loginState.inputOne.id]
                                                        .length > 5
                                                    ? false
                                                    : true
                                            : false
                                    }
                                    style={{
                                        background: loginState.inputOne
                                            ? loginState.inputTwo
                                                ? // this.state[loginState.inputOne.id] &&
                                                this.state[
                                                    loginState.inputOne.id
                                                ] &&
                                                    (loginState.inputOne.className ===
                                                        "password"
                                                        ? this.state[
                                                            loginState.inputOne.id
                                                        ].length > 5
                                                        : true) &&
                                                    this.state[
                                                    loginState.inputTwo.id
                                                    ] &&
                                                    (loginState.inputTwo.className ===
                                                        "password"
                                                        ? this.state[
                                                            loginState.inputTwo.id
                                                        ].length > 5
                                                        : this.state[
                                                            loginState.inputTwo.id
                                                        ].length > 3) &&
                                                    !msgOne &&
                                                    !msgTwo &&
                                                    this.state.agree
                                                    ? `url(${require("../static/img/login-register/button-active.png")}) no-repeat center / contain`
                                                    : `url(${require("../static/img/login-register/button.png")}) no-repeat center / contain`
                                                : this.state[
                                                    loginState.inputOne.id
                                                ] &&
                                                    !msgOne &&
                                                    this.state[loginState.inputOne.id]
                                                        .length > 5
                                                    ? `url(${require("../static/img/login-register/button-active.png")}) no-repeat center / contain`
                                                    : `url(${require("../static/img/login-register/button.png")}) no-repeat center / contain`
                                            : `url(${require("../static/img/login-register/button-active.png")}) no-repeat center / contain`
                                    }}
                                    onClick={() => {
                                        this.bigButtonHandler(loginState);
                                    }}
                                >
                                    {loginState.buttonText.content}
                                </button>
                                // </div>
                            )}

                            {loginState.id !== 5 && loginState.tips ? (
                                <div className={loginState.tips.className}>
                                    {loginState.tips.one && (
                                        <div
                                            className="code"
                                            onClick={() => {
                                                this.changeStateHandler(
                                                    loginState.tips.one.updateState
                                                );
                                            }}
                                        >
                                            {loginState.tips.one.content}
                                        </div>
                                    )}
                                    {loginState.tips.two && (
                                        <div
                                            className="forget"
                                            onClick={() => {
                                                this.changeStateHandler(
                                                    loginState.tips.two.updateState
                                                );
                                            }}
                                        >
                                            {loginState.tips.two.content}
                                        </div>
                                    )}
                                </div>
                            ) : null}

                            {loginState.id !== 5 && this.state.tips && (
                                <div className="tips">{this.state.tips}</div>
                            )}

                            {loginState &&
                                (loginState.id !== 5 && loginState.id !== 8 && !isWX && !window.isMobile) && (
                                    <div className="login-with">
                                        {/* <div className="login-with-content">
              <div className="line" />
              <div className="login-with-content-text">第三方账号登录</div>
              <div className="line" />
            </div> */}
                                        <button
                                            onClick={() => {
                                                this.weixinLoginHandler();
                                            }}
                                            className="login-with-logo"
                                        />
                                        <div className="login-with-tips">
                                            微信扫码登录
                                    </div>
                                    </div>
                                )}
                            {loginState && loginState.id === 2 && (
                                <div className="statement-container">
                                    {/* <div
                  className="statement-checkbox"
                  onClick={() => {
                    this.setState({
                      agree: this.state.agree === true ? false : true
                    });
                  }}
                  style={{
                    background: this.state.agree
                      ? `url(${require("../static/img/login-register/agree.png")}) no-repeat`
                      : `url(${require("../static/img/login-register/no-agree.png")}) no-repeat`,
                    backgroundSize: "100%"
                  }}
                /> */}
                                    <div className="statement-content">
                                        注册即同意
                                    <a
                                            target="blank"
                                            href="/onlinepages/course_assist/u/userProtocol_c.html"
                                        >
                                            《用户协议》
                                    </a><br />
                                        <a
                                            target="blank"
                                            href="/onlinepages/course_assist/u/privacy_c.html"
                                        >
                                            《隐私协议》
                                    </a>
                                        及
                                    <a
                                            target="blank"
                                            href="/onlinepages/course_assist/u/kids_privacy_c.html"
                                        >
                                            《儿童隐私政策》
                                    </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {showDeviceDialog &&
                    <DeviceBindDialog
                        type='bind'
                        contentText='绑定的设备过多！'
                        buttonLeftText='退出登录'
                        buttonRightText='绑定管理'
                        buttonLeftClick={() => { this.handleLoginOut() }}
                        buttonRightClick={() => { this.handleShowDeviceManagement() }}
                    />
                }
                {showDeviceManagement &&
                    <DeviceManagement
                        handleBack={this.handleDeviceManagementBack.bind(this)}
                        handleBindSuccess={this.successLink.bind(this)}
                    />
                }
            </React.Fragment>
        );
    }
}

export default Login;

const InputPassword = ({
    input,
    onChange,
    onClick,
    msg,
    value,
    type,
    onBlur
}) => {
    return (
        <div className="input-container">
            <input
                placeholder={input.placeholder}
                className={input.className}
                value={value}
                type={type}
                onChange={onChange}
                onBlur={onBlur}
                name={input.name}
            />
            {value && (
                <div
                    className="eyes"
                    style={{
                        top: type === "password" ? "15px" : "10px",
                        background:
                            type === "password"
                                ? `url(${require("../static/img/login-register/close-eyes.png")}) no-repeat 0 0 / 100%`
                                : `url(${require("../static/img/login-register/open-eyes.png")}) no-repeat 0 0 / 100%`,
                        backgroundSize: "100%"
                    }}
                    onClick={onClick}
                />
            )}
            {msg && <div className="msg">{msg}</div>}
        </div>
    );
};

// 定义子组件需要使用的属性
Login.contextTypes = {
    getUser: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/route/Login.js